import {
  ButtonProps as CButtonPros,
  Button as ChakraButton,
} from '@chakra-ui/react';
import useTranslate from '~/common/utils/translate';
import React from 'react';

type ButtonProps = CButtonPros & {
  params?: string[];
  ref?: React.MutableRefObject<any>;
};

export const Button: React.FC<ButtonProps> = ({
  params,
  children,
  ...props
}) => {
  const translate = useTranslate();
  return <ChakraButton {...props}>{translate(children, params)}</ChakraButton>;
};
